import React from 'react';
import clsx from 'clsx';
import TierBadge from '@components/common/TierBadge';
import { tierToVariant } from '@utils/badgeMappers';
import styles from './AssessmentCell.module.css';

export interface AssessmentCellProps {
  name: string;
  supplierName?: string;
  tierName?: string;
  className?: string;
}

const AssessmentCell: React.FC<AssessmentCellProps> = ({ name, supplierName, tierName, className }) => {
  return (
    <div className={clsx(styles.assessmentCell, className)}>
      <div className={styles.assessmentInfo}>
        <div className={styles.assessmentName}>{name}</div>
        {(supplierName || tierName) && (
          <div className={styles.assessmentDetails}>
            {supplierName && <span className={styles.supplierName}>{supplierName}</span>}
            {tierName && <TierBadge variant={tierToVariant(tierName)}>{tierName}</TierBadge>}
          </div>
        )}
      </div>
    </div>
  );
};

export default AssessmentCell;
